
import Vue from "vue";

import ActivitiesMixin from "@/components/ActivitiesView/ActivitiesMixin.vue";
import ActivitiesTimelineItem from "@/components/ActivitiesView/ActivitiesTimelineItem.vue";

interface AgenciesActivitiesData {
  error: string;
  message: string;
}

export default Vue.extend({
  name: "AgenciesActivitiesView",
  components: { ActivitiesTimelineItem },
  mixins: [ActivitiesMixin],

  data(): AgenciesActivitiesData {
    return {
      error: "",
      message: ""
    };
  },
  computed: {
    queryOverride(): any {
      return {
        name__in: `
          ADD_AGENCY_SUCCESS,
          ADD_AGENCY_FAILURE,
          UPDATE_AGENCY_SUCCESS,
          UPDATE_AGENCY_FAILURE,
          DELETE_AGENCY_SUCCESS,
          DELETE_AGENCY_FAILURE,
          ASSIGN_USER_TO_AGENCY_SUCCESS,
          ASSIGN_USER_TO_AGENCY_FAILURE
          `.replace(/\s/g, ""),
        activityType: "AgencyActivity"
      };
    }
  }
});
